/**
 * Cognitive Reappraisal — chargement des scénarios FR + EN.
 *
 * Format : 1 fichier JSON par lang dans `apps/web/public/dictionaries/`,
 * importé en build-time par Vite (inlined dans le bundle, ~5 KB par lang).
 *
 * Choix sober : 30+ scénarios universels (file d'attente, retard, conflit
 * collègue, désaccord ami) — JAMAIS deuil, accident grave, trauma.
 */
import scenariosFrRaw from '../../../public/dictionaries/reappraisal-scenarios-fr.json';
import scenariosEnRaw from '../../../public/dictionaries/reappraisal-scenarios-en.json';
const BANKS = {
    fr: scenariosFrRaw,
    en: scenariosEnRaw,
};
export function getBank(lang) {
    return BANKS[lang];
}
/**
 * Sélectionne un scénario de la complexity demandée. Si plusieurs
 * candidats, choix déterministe via `seed` (trialIdx). Si aucun candidat
 * exact, fallback sur la complexity la plus proche.
 */
export function pickScenario(lang, complexity, seed) {
    const bank = getBank(lang);
    const exact = bank.scenarios.filter((s) => s.complexity === complexity);
    if (exact.length > 0) {
        const idx = ((seed >>> 0) % exact.length) | 0;
        return exact[idx];
    }
    // Fallback : complexity proche supérieure ou égale.
    const above = bank.scenarios
        .filter((s) => s.complexity >= complexity)
        .sort((a, b) => a.complexity - b.complexity);
    if (above.length > 0) {
        const idx = ((seed >>> 0) % above.length) | 0;
        return above[idx];
    }
    // Dernier recours : complexity max.
    const sorted = [...bank.scenarios].sort((a, b) => b.complexity - a.complexity);
    return sorted[0];
}
/**
 * Clamp rating 1-9 (échelle SAM-like).
 */
export function clampRating(value) {
    return Math.max(1, Math.min(9, Math.round(value)));
}
//# sourceMappingURL=data.js.map